import uuidV4 from 'uuid/v4';

export function generateUuid() {
  return uuidV4();
}

export function generateShortId() {
  return Date.now().toString(36);
}
